export const FETCH_SWITCH_INSTRUCTION_PATTERNS =
    "switchRequests/FETCH_SWITCH_INSTRUCTION_PATTERNS"
export const SET_SWITCH_INSTRUCTION_PATTERNS =
    "switchRequests/SET_SWITCH_INSTRUCTION_PATTERNS"
export const FETCH_SWITCH_INSTRUCTION_PATTERNS_FAILED =
    "switchRequests/FETCH_SWITCH_INSTRUCTION_PATTERNS_FAILED"
export const CREATE_SWITCH_INSTRUCTION =
    "switchRequests/CREATE_SWITCH_INSTRUCTION"
export const CREATE_SWITCH_INSTRUCTION_SUCCESS =
    "switchRequests/CREATE_SWITCH_INSTRUCTION_SUCCESS"
export const CREATE_SWITCH_INSTRUCTION_FAILURE =
    "switchRequests/CREATE_SWITCH_INSTRUCTION_FAILURE"
export const SWITCH_REQUESTS_FETCH_DATA =
    "switchRequests/SWITCH_REQUESTS_FETCH_DATA"
export const SWITCH_REQUESTS_DATA_SUCCESS =
    "switchRequests/SWITCH_REQUESTS_DATA_SUCCESS"
export const SWITCH_REQUESTS_DATA_FAILURE =
    "switchRequests/SWITCH_REQUESTS_DATA_FAILURE"
export const SWITCH_REQUESTS_FETCH_FILTER =
    "switchRequests/SWITCH_REQUESTS_FETCH_FILTER"
